export default __webpack_public_path__ + "static/char-s-50-zh-Hant-c06b600426c61b7f98d965c6994a2b58.webp";